import { IStoreState, ThunkDispatch } from '../../modules';
import { MuiThemeProvider, Theme, WithStyles, createMuiTheme, createStyles, withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import { ConnectedRouter } from 'connected-react-router';
import CssBaseline from '@material-ui/core/CssBaseline';
import MainApp from './MainApp';
import ProxySelector from './ProxySelector';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { history } from '../../store';

const theme = createMuiTheme({
  typography: {
    h3: {
      fontWeight: 300,
    },
    h4: {
      fontWeight: 300,
    },
  },
});

const styles = (theme: Theme) => createStyles({
  '@global': {
    '.maxWidth': {
      width: 'auto',
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
      [theme.breakpoints.up(900 + theme.spacing(3 * 2))]: {
        maxWidth: 900,
        width: 900,
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    'body': {
      // image only set on login page
      backgroundAttachment: "fixed",
      backgroundSize: "cover",
      backgroundPosition: "bottom center",
    },
    '#pageHeader': {
      margin: `${theme.spacing(2)}px 0 ${theme.spacing(3)}px`,
      color: '#666',
    },
    '.flag-icon': {
      boxShadow: '0 0 1px rgba(0,0,0,0.5)'
    },
    '.flag-icon-hidden': {
      visibility: 'hidden'
    },
    '.error': {
      color: theme.palette.error.dark
    },
  },

});

type State = {
  proxyId: string | null
}

class App extends Component<Props, State> {
  state: State = {
    proxyId: null,
  }

  render() {
    return (
      <ConnectedRouter history={history}>
        <CssBaseline />
        <MuiThemeProvider theme={theme}>
          <Switch>
            <Route path={"/proxy/:proxyId([A-Za-z0-9]{4,8})"} render={props => <MainApp mode="proxy" {...props} />} />
            <Route path={"/direct"} render={props => <MainApp mode="direct" {...props} />} />
            <Route path={"/bypass"} render={props => <MainApp mode="bypass" {...props} />} />
            <Route component={ProxySelector} />
          </Switch>
        </MuiThemeProvider>
      </ConnectedRouter>
    )
  }
}

const mapStateToProps = (_: IStoreState) => ({

})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {

}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(App));